/**
 * IUROP - Cross-sell Popup
 * Shows a popup when a product from a trigger collection is added to cart.
 * Blocks the sidecart from opening while the popup is active.
 */
(function () {
  var popup = document.getElementById('iurop-cross-sell-popup');
  if (!popup) return;

  var triggerCollection = popup.dataset.triggerCollection || '';
  var closeButtons = popup.querySelectorAll('[data-cross-sell-close]');
  var addBtn = popup.querySelector('[data-cross-sell-add]');
  var variantSelect = popup.querySelector('[data-cross-sell-variant-select]');
  var offerPriceEl = popup.querySelector('[data-cross-sell-offer-price]');
  var addedImg = popup.querySelector('[data-cross-sell-added-img]');
  var addedName = popup.querySelector('[data-cross-sell-added-name]');
  var addedPrice = popup.querySelector('[data-cross-sell-added-price]');
  var addBtnText = addBtn ? addBtn.textContent.trim() : 'AÑADIR';

  function openSidecart() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && cartDrawer.showDialog) {
      cartDrawer.showDialog();
    } else if (cartDrawer) {
      var dialog = cartDrawer.querySelector('dialog');
      if (dialog) dialog.showModal();
    }
  }

  function refreshDrawerIfPossible() {
    if (typeof window.refreshCartDrawer === 'function') {
      return Promise.resolve(window.refreshCartDrawer()).catch(function () {});
    }
    return Promise.resolve();
  }

  // ── Variant prices map (from data attribute) ──
  var variantPrices = {};
  try {
    variantPrices = JSON.parse(popup.dataset.variantPrices || '{}');
  } catch (e) { /* ignore */ }

  // ── Global flag: blocks sidecart from opening ──
  window.__iuropCrossSellPending = false;

  // Update variant ID + price when select changes
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var selectedId = this.value;
      if (addBtn) addBtn.dataset.variantId = selectedId;
      // Update displayed price
      if (offerPriceEl && variantPrices[selectedId]) {
        offerPriceEl.textContent = variantPrices[selectedId];
      }
    });
  }

  // ── Close popup ──
  function closePopup(shouldOpenSidecart) {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.__iuropCrossSellPending = false;

    if (shouldOpenSidecart) {
      refreshDrawerIfPossible().finally(function () {
        setTimeout(function () {
          openSidecart();
        }, 120);
      });
    }
  }

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closePopup(true);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup(true);
    }
  });

  // ── Open popup (and force-close sidecart if it somehow opened) ──
  function openPopup(productData) {
    // Fill added product info
    if (addedImg && productData.image) {
      addedImg.src = productData.image;
      addedImg.alt = productData.title || '';
    }
    if (addedName) addedName.textContent = productData.title || '';
    if (addedPrice) addedPrice.textContent = productData.price || '';

    // Reset cross-sell variant to first option
    if (variantSelect) {
      variantSelect.selectedIndex = 0;
      var firstId = variantSelect.value;
      if (addBtn) addBtn.dataset.variantId = firstId;
      if (offerPriceEl && variantPrices[firstId]) {
        offerPriceEl.textContent = variantPrices[firstId];
      }
    }

    // Reset add button state
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = addBtnText;
    }

    // Force-close any open sidecart/cart-drawer
    forceSidecartClosed();

    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function forceSidecartClosed() {
    // Horizon native cart drawer
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      var dialog = cartDrawer.querySelector('dialog');
      if (dialog && dialog.hasAttribute('open')) {
        dialog.close();
      }
    }
  }

  // ── Add cross-sell product to cart ──
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variantId = this.dataset.variantId;
      if (!variantId) return;

      this.disabled = true;
      this.textContent = 'Añadiendo...';

      if (typeof window.iuropAddToCart === 'function') {
        window.iuropAddToCart({
          variantId: String(variantId),
          quantity: 1,
          sourceId: 'iurop-cross-sell',
          openSidecartAfter: false
        })
          .then(function(result) {
            if (!result || !result.ok) {
              addBtn.textContent = (result && result.error && result.error.message) || 'Error';
              setTimeout(function () {
                addBtn.disabled = false;
                addBtn.textContent = addBtnText;
              }, 2000);
              return;
            }

            refreshDrawerIfPossible().finally(function () {
              addBtn.textContent = '¡Añadido!';
              setTimeout(function () {
                closePopup(false);
                addBtn.disabled = false;
                addBtn.textContent = addBtnText;
                openSidecart();
              }, 600);
            });
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = addBtnText;
          });
        return;
      }

      var cartItemsComponents = document.querySelectorAll('cart-items-component');
      var sectionIds = [];
      cartItemsComponents.forEach(function (item) {
        if (item.dataset && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: String(variantId),
          quantity: 1,
          sections: sectionIds.join(',')
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            addBtn.textContent = data.message || 'Error';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = addBtnText;
            }, 2000);
            return;
          }

          // Update cart count + refresh cart drawer content
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'iurop-cross-sell',
                  data: { source: 'iurop-cross-sell', itemCount: cart.item_count || 0 }
                }
              }));
            });

          refreshDrawerIfPossible().finally(function () {
            addBtn.textContent = '¡Añadido!';
            setTimeout(function () {
              closePopup(false);
              addBtn.disabled = false;
              addBtn.textContent = addBtnText;

              // Open sidecart only after drawer content refresh
              openSidecart();
            }, 600);
          });
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = addBtnText;
        });
    });
  }

  // ── Intercept add-to-cart: set pending flag BEFORE submit ──
  var pendingProductInfo = null;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.closest('#iurop-cross-sell-popup')) return;
    if (!triggerCollection) return;

    var productMeta = document.querySelector('[data-iurop-crosssell-product]');
    if (!productMeta) return;

    var productCollections = (productMeta.dataset.collections || '').split(',').map(function (s) { return s.trim(); });

    var shouldTrigger = productCollections.some(function (col) {
      return col === triggerCollection;
    });

    if (shouldTrigger) {
      // Set global flag BEFORE the cart:update fires → blocks sidecart
      window.__iuropCrossSellPending = true;

      pendingProductInfo = {
        title: productMeta.dataset.title || '',
        image: productMeta.dataset.image || '',
        price: productMeta.dataset.price || ''
      };
    }
  }, true); // capture phase → runs before other handlers

  // ── Listen for successful cart addition → show popup ──
  document.addEventListener('cart:update', function (e) {
    if (!pendingProductInfo) return;
    if (e.detail && e.detail.sourceId === 'iurop-cross-sell') return;

    var info = pendingProductInfo;
    pendingProductInfo = null;

    // Small delay so the ATC animation finishes, then show popup
    setTimeout(function () {
      // Force close sidecart in case it opened before our flag was checked
      forceSidecartClosed();
      openPopup(info);
    }, 150);
  });

  // ── Patch: block cart drawer from opening when cross-sell is pending ──
  // Override showDialog on cart-drawer-component
  function patchCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer || cartDrawer.__iuropPatched) return;
    cartDrawer.__iuropPatched = true;

    var originalShowDialog = cartDrawer.showDialog;
    if (typeof originalShowDialog === 'function') {
      cartDrawer.showDialog = function () {
        if (window.__iuropCrossSellPending) return; // ← blocked
        return originalShowDialog.apply(this, arguments);
      };
    }

    // Also patch the open() method if it exists
    var originalOpen = cartDrawer.open;
    if (typeof originalOpen === 'function') {
      cartDrawer.open = function () {
        if (window.__iuropCrossSellPending) return; // ← blocked
        return originalOpen.apply(this, arguments);
      };
    }
  }

  // Patch as soon as possible and after DOMContentLoaded
  patchCartDrawer();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
  }
  // Also patch after a short delay in case the component loads async
  setTimeout(patchCartDrawer, 500);
  setTimeout(patchCartDrawer, 1500);
})();
